import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import * as api from '../../api';
import Card from '../../components/card/Card'
import { Grid, Button  } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import CaseTableHeader from "./case-table-header";
import CaseTableRow from "./case-table-row";
import {from} from "linq";
import FieldDonutChart from "../../components/charts/custom/field-donut-chart";
import {MultiDateFilter} from "../../components/table/filters/multi-date-filter";
import Currency from "../../components/formatters/currency";
import MonthlyEventTypeChart from "../../components/charts/custom/monthly-event-type-chart";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';
import moment from "moment";
import CreateCase from './create-case';
import { AuthService } from '../../services/auth-service'
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary



function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

class ServiceManagement extends Component {
    static contextType = BreadcrumbContext;

    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ApiDataProvider(api.getCaseList, [this.props.customerId,this.props.siteKey,this.props.meterSiteKey,"false"]),
            queriesList: [],
            netSavings: 0,
            totalQueries: 0,
            totalClosedQueries: 0,
            totalPendingQueries: 0,
            currentChartClick : "",
            filterValue: "", // This state will hold the filter value

        }
    }


    

    calculateNetSavings(cases) {
        return from(cases)
            .sum(x => x.netSaving).toFixed(2);
    }

    countStatus(cases, status) {
        return from(cases)
            .count(x => x.status === status);
    }

    handleCardClick = (e) => {

        var status = null


        if(e === "All")
        {
            this.filterableDataTableRef.onAdvancedFilterChange({
               
                name : "Status",
                value: ""
              });
              this.setState({
                filterValue: ""
                })

        }else if (e === "Closed")
        {
            this.filterableDataTableRef.onAdvancedFilterChange({
                name : "Status",
                value: "Closed"
              });
              this.setState({
                filterValue: ""
                })
              status = "Closed"

        }else if (e === "Open")
        {
            this.filterableDataTableRef.onAdvancedFilterChange({
                name : "Status",
                value: "In Progress"
              });

              this.setState({
                filterValue: ""
                })

              status = "In Progress"

        }else if (e === "Net")
        {
            if(this.state.filterValue === "Showing cases with net savings above zero")
            {
                this.setState({
                    filterValue: ""
                    })
            }else
            {
            this.setState({
                                filterValue: "Showing cases with net savings above zero"
            })
        }
             
          
        }


        this.setState({
            statusOverride: status
        })
    }


    handleMonthlyChartClick = (evt, element) => {
        if (element.length > 0) {
            const firstPoint = element[0]._chart.getElementAtEvent(evt)[0];
            const index = firstPoint._index;
    
            // Calculate the start date 24 months before the current month
            const currentDate = new Date();
            const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 23, 1);  // Set to the first of the month
    
            // Calculate the clicked date by adding the index months to the start date
            const clickedDate = new Date(startDate.setMonth(startDate.getMonth() + index));
    
            this.setState({
                initialDate : clickedDate})
           
        }
    };


    handleChartClick = (e) => {
        if(e.length !== 0)
        {
        var label = e[0]._view.label
        if(this.state.currentChartClick === label)
        {
            this.setState({
                currentChartClick : ""})
           
              this.filterableDataTableRef.onAdvancedFilterChange({
                name : "QueryType",
                value: ""
              });

              this.filterableDataTableRef.onAdvancedFilterChange({
                name : "Status",
                value: ""
              });

              this.setState({
                queryTypeOverride: ""
            })
 
        }else
        {
            this.setState({
                currentChartClick : label})


        this.filterableDataTableRef.onAdvancedFilterChange({
            name : "QueryType",
            value: label
          });

          this.filterableDataTableRef.onAdvancedFilterChange({
            name : "Status",
            value: "In Progress"
          });

          
      

        this.setState({
            queryTypeOverride: label
        })


        }
        }else
        {
            if(this.state.currentChartClick !== "")
{
              this.filterableDataTableRef.onAdvancedFilterChange({
                name : "QueryType",
                value: ""
              });
    
              this.filterableDataTableRef.onAdvancedFilterChange({
                name : "Status",
                value: ""
              });
      
              this.setState({
                queryTypeOverride: "",
                  currentChartClick : ""
            })
        }
        }

        

      };

      
      

    render() {
        const authServices = new AuthService();


        const filteredQueriesList = this.state.queriesList.filter(item => {
            const dateLogged = moment(item.dateLogged, 'YYYY-MM-DDThh:mm:ss');
            return dateLogged.isAfter(moment().subtract(2, 'years'));
          });

          const inProgressQueriesList = this.state.queriesList.filter(item => {
            return item.status === "In Progress";
          });

        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Service Management</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Case Management</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <Card metric={this.state.totalQueries} title={"Total Cases to Date"} popupText={"This is the total number of queries you have raised."}
                                                        onClick={(e) => this.handleCardClick("All")}
                                                        />
                        </Grid.Column>
                        <Grid.Column>
                            <Card metric={this.state.totalClosedQueries} title={"Completed Cases to Date"} popupText={"This is the total number of completed queries."} 
                            onClick={(e) => this.handleCardClick("Closed")}
                                                        />
                            
                        </Grid.Column>
                        <Grid.Column>
                            <Card metric={this.state.totalPendingQueries} title={"Pending Cases to Date"} popupText={"This is the total number of pending queries."}
                            onClick={(e) => this.handleCardClick("Open")}
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <Card metric={<Currency value={this.state.netSavings} skeleton />} title={"Net Savings To Date"} popupText={"This is the total of net savings over the date period"} 
                              onClick={(e) => this.handleCardClick("Net")}
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                  

                        <Grid.Column width={6}>
                            {!!inProgressQueriesList.length > 0 && <FieldDonutChart data={inProgressQueriesList} field={"queryType"} title={"Open cases by type"} 
                            onElementsClick={(e) => this.handleChartClick(e)}
                            
                            /> }
                        </Grid.Column>

                        <Grid.Column width={10}>
                            {!!this.state.queriesList.length > 0 && <MonthlyEventTypeChart title={"Cases raised by Month"} 
                             onElementsClick={((e,element) => this.handleMonthlyChartClick(e,element))}
                             data={filteredQueriesList} /> }
                        </Grid.Column>
                    </Grid.Row>



                    <Grid.Row>
                        <Grid.Column>
                            <h2>Cases</h2>
                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column>
                    {(authServices.hasCaseManActive(this.props.customerId)) &&

                    <CreateCase assetLabel="Create New Case"></CreateCase>
                    }
                         <Button.Group compact floated='right'>
                        {/* <Button floated='right' id='case-report' href="/reports?trigger=casereport">Case Report</Button> */}
                        <Link to="/reports?trigger=casereport">
      <Button floated='right' id='case-report'>
        Case Report
      </Button>
    </Link>
                        </Button.Group>
                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row>
                   
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider}    ref={(ref) => (this.filterableDataTableRef = ref)} 
                                
                                filterComponentProps={{
                                    initialDate: this.state.initialDate, // Make sure this is passed correctly

                                    filter: this.state.filterValue, // Pass the filter value to DateFilterSupplierInvoices
                                    filterValue: this.state.filterValue, // Ensure you are passing this
                                }}
                                filterComponent={MultiDateFilter} name="cases" canExport={false} storeName="caseList" clearStore={ this.getStoreageRule() }
                                                     headerComponent={CaseTableHeader} rowComponent={CaseTableRow}
                                                      defaultSort={"caseNumber"}
                                                      fromDateLabel={"From Logged Date"}
                                                      toDateLabel={"To Logged Date"}
                                                      multiFromDateLabel={"From Completed Date"}
                                                      multiToDateLabel={"To Completed Date"}
                                                      statusOverride={this.state.statusOverride}
                                                      queryTypeOverride={this.state.queryTypeOverride}
                                                      initialDate= {this.state.initialDate} // Ensure this is correctly derived and passed down                                                    

                                                      />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
    componentDidMount = () => {
     

        this.context.addBreadcrumb({ title: "Case Management" , path: '/service-management' });

                             
        const cardClicked = this.props.location?.state?.cardClicked;
       
        var status = ""
        var filterNet = false
        switch (cardClicked) {
            case "Closed":
               
                this.filterableDataTableRef.onAdvancedFilterChange({
                    name : "Status",
                    value: "Closed"
                  });
        
              
                status = "Closed"
                break;
            case "Open":

                this.filterableDataTableRef.onAdvancedFilterChange({
                    name : "Status",
                    value: "In Progress"
                  });


                status = "In Progress"

                break;
            case "Net":

            this.filterableDataTableRef.onAdvancedFilterChange({
                name : "Status",
                value: ""
              });
            status = ""

            filterNet = true
            break;
            default:

                this.filterableDataTableRef.onAdvancedFilterChange({
                    name : "Status",
                    value: ""
                  });
                status = ""
                break;
        }
        this.setState({
            statusOverride: status
        })

        this.fetchData(status,filterNet);

        ReactGA.pageview('case management');
    }

    getStoreageRule() {
        try 
        {
           
           return  this.props.location.state.clearStore; // better way to check undefined but i'm going mad today
         } catch
          {
              return false
          }
       }

       fetchData = (status,filterNet) => {
        api.getCaseList(this.props.customerId, this.props.siteKey, this.props.meterSiteKey,filterNet)
            .then(queriesList => {

               
                this.setState({
                    queriesList: queriesList.data,
                    totalQueries: queriesList.data.length,
                    totalClosedQueries: this.countStatus(queriesList.data,"Closed"),
                    totalPendingQueries: this.countStatus(queriesList.data,"In Progress"),
                    netSavings: this.calculateNetSavings(queriesList.data)
                }, () => {
                    // This callback ensures that filters are applied after state is updated
                    if(status === "") {
                      
                        this.filterableDataTableRef.onAdvancedFilterChange({
                            name : "Status",
                            value: ""
                          });
                    } else if (status === "Closed") {
                       
                        this.filterableDataTableRef.onAdvancedFilterChange({
                            name : "Status",
                            value: "Closed"
                          });


                    } else if (status === "In Progress") {
                      
                        this.filterableDataTableRef.onAdvancedFilterChange({
                            name : "Status",
                            value: "In Progress"
                          });
                    }

                    this.forceUpdate();


                    if(status === "") {
                    

                        this.filterableDataTableRef.onAdvancedFilterChange({
                            name : "Status",
                            value: ""
                          });
                    } else if (status === "Closed") {
                        
                        this.filterableDataTableRef.onAdvancedFilterChange({
                            name : "Status",
                            value: "Closed"
                          });


                    } else if (status === "In Progress") {
                        
                        this.filterableDataTableRef.onAdvancedFilterChange({
                            name : "Status",
                            value: "In Progress"
                          });
                    }

                    this.forceUpdate();

                });
            });
    }
}

const wrap = connect(mapStateToProps, mapDispatchToProps);
export default wrap(ServiceManagement);